import SidePanelHeader from './SidePanelHeader';

export default SidePanelHeader;
